<template>
    <div id="root" class="quanping">
        <div class="column pagestyle___3At3P" style="height: 100%;position: relative;">
            <div class="row">
                <div class="ant-form ant-form-horizontal layui-form form-horizontal p-15" id="form-style">
                    <div class="row" style="margin-bottom: 20px;">
                        <i class="iconfont" style="color: #faad14; font-size: 18px; margin-right: 5px;"></i>
                        <h2 style="font-size: 18px; color: rgb(21, 21, 21); margin: 0px; flex: 1 1 0%;">欢迎注册</h2>
                    </div>
                    <table class="table table-bordered">
                        <tbody>
                            <tr>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        <span style="color: red;">*</span>单位名称：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <el-input v-model="unitName" placeholder="请输入单位名称"></el-input>
                                            </span>
                                        </span>
                                    </div>
                                </td>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        <span style="color: red;">*</span>
                                        单位电话：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <el-input v-model="unitTelephone" placeholder="请输入单位电话"></el-input>
                                            </span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        <span style="color: red;">*</span>单位联系人：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <span class="ant-input-affix-wrapper" style="height: 40px;">
                                        <el-input v-model="unitContacts" placeholder="请输入单位联系人"></el-input>
                                    </span>

                                </td>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        <span style="color: red;">*</span>联系电话：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <span class="ant-input-affix-wrapper" style="height: 40px;">
                                        <el-input v-model="unitContactsTel" placeholder="请输入单位联系人手机号码"></el-input>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        单位级别：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <el-select v-model="unitLevelStr" placeholder="请选择"
                                                    style="width: 100%;">
                                                    <el-option v-for="(item,index) in unitLevelStrList" :key="index"
                                                        :label="item" :value="item"> </el-option>
                                                </el-select>

                                            </span>
                                        </span>
                                    </div>
                                </td>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        单位性质：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <el-select v-model="unitNatureStr" placeholder="请选择"
                                                    style="width: 100%;">
                                                    <el-option v-for="(item,index) in unitNatureStrList" :key="index"
                                                        :label="item" :value="item"> </el-option>
                                                </el-select>
                                            </span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        所属行业：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <el-input v-model="unitIndustryStr" @focus="aaa()"
                                                    placeholder="点击选择所属行业"></el-input>
                                            </span>
                                        </span>
                                    </div>
                                </td>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        单位地址：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <el-input v-model="unitAddress" placeholder="请输入单位地址"></el-input>
                                            </span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        类型：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <el-radio v-model="radio" label="1">院校</el-radio>
                                                <el-radio v-model="radio" label="2">社会</el-radio>
                                            </span>
                                        </span>
                                    </div>
                                </td>

                                <td class="width-15 active">
                                    <label class="pull-right">
                                        登录密码：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div class="ant-form-item-control">
                                        <span class="ant-form-item-children">
                                            <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                <el-input v-model="unitPassword" placeholder="请输入登录密码" show-password>
                                                </el-input>

                                            </span>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="width-15 active">
                                    <label class="pull-right">
                                        <span style="color: red;">*</span>统一社会信用码：
                                    </label>
                                </td>
                                <td class="width-35">
                                    <div>
                                        <div class="ant-form-item-control">
                                            <span class="ant-form-item-children">
                                                <span class="ant-input-affix-wrapper" style="height: 40px;">
                                                    <el-input v-model="unitCertificatesCode" placeholder="请输入社会统一信用码">
                                                    </el-input>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <span style="color: green;">统一社会信用码即单位登录账号</span>
                                </td>
                                <td class="width-15 active">
                                    <label class="pull-right">证件照：</label>
                                </td>
                                <td class="width-35">

                                    <el-upload class="avatar-uploader" :action="actionImageUrl"
                                        :on-success="handleAvatarSuccess" :before-upload="beforeUpload" :limit='1'
                                        accept=".jpg,.jpeg,.png,.pdf,.JPG,.JPEG,.PDF,.PNG">

                                        <div class="layui-upload-drag" id="test10">
                                            <i class="layui-icon"></i>
                                            <p>点击上传，或将文件拖拽到此处</p>
                                            <div class="layui-hide" id="uploadDemoView">
                                                <hr>
                                                <span></span>
                                            </div>
                                        </div>
                                    </el-upload>
                                    <div style="color: red;font-size: 12px;">
                                        请上传统一社会信用代码证件。附件必须为2M以内。<br>
                                        格式：*.jpg|*.jpeg|*.gif|*.bmp|*.png的图片。
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <a class="layui-btn layui-bg-green" @click="signUpRightAway"
                        style="display: inline-block;margin-right: 22px;">立即注册</a>
                    <a href="/" class="layui-btn layui-bg-green shouye"
                        style="display: inline-block;margin-right: 22px;">返回首页</a>
                    <div style="width: 50%; float: left; margin-top: 6px;">
                        <a class="loginCompany" @click="immediately" style="color: red;">已有账号！立即登录</a>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="所属行业" :visible.sync="dialogVisible" width="30%">
            <v-tree :data="data" @select="select" show-line style="height: 400px;overflow: scroll;"></v-tree>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    //import homePage from './components/homePage.vue';
    import Vue from 'vue'
    import 'vue-beauty/package/style/vue-beauty.min.css'
    // vue-beauty 树形组件 单独引入
    //import {tree} from 'vue-beauty' 
    //Vue.use(tree)

    //vue-beauty 多有组件全部引入
    import vuebeauty from 'vue-beauty'
    Vue.use(vuebeauty)
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                actionImageUrl: '',//上传证件照片路径
                radio: '1', //单位类型  1院校   2社会  
                unitPassword: '', //单位用户 登录密码
                data: [],  //所属行业列表
                dialogVisible: false,  //控制所属行业显示不显示  false 不显示  true 显示
                unitName: '',  //单位名称
                unitTelephone: '', // 单位电话
                unitContacts: '', // 单位联系人
                unitContactsTel: '', //单位联系人手机号码
                unitLevelStr: '',
                unitNatureStr: '',//单位性质
                unitCertificates:'',//单位相关证件
                unitIndustryStr: '',//所属行业
                unitAddress:'',
                unitCertificatesCode:'',//社会统一代码
                unitLevelStrList: [
                    '中央、国家级(正)', '中央、国家级(副)', '省、部级', '副省、副部级', '地、厅、司、局级', '副地、副厅、副司、副局级', '县、处级'
                    , '副县、副处级', '乡、科级', '副乡、副科级', '股级', '大行政区(军政委员会)', '中央军委级', '解放军总部级', '大军区正级', '大军区副级',
                    '正兵团级', '副兵团级', '正军级', '副军级', '正师级', '副师(正旅)级', '正团(副旅)级', '副团级', '正营级', '副营级', '正连级', '副连级',
                    '排级', '班级', '国际组织、机构', '外国组织、机构', '无级别', '其他'
                ],
                unitNatureStrList: [
                    '机关', '事业单位', '企业', '社会团体', '军队', '宗教团队', '其他单位', '全额拨款事业单位', '差额拨款事业单位', '自收自支事业单位',
                    '中央', '其他事业单位'
                ]

            }
        },
        created() {
            this.actionImageUrl = this.serverUrl + '/deUp/uploadUnitCertificates';
            this.loadData();
        },
        mounted() {
        },
        methods: {
            //正面
            handleAvatarSuccess(response, file, fileList) {
                this.unitCertificates = response.src;

                console.log(this.unitCertificates)
                this.$message({
                    showClose: true,
                    message: '恭喜你，文件上传成功！',
                    type: 'success'
                });
            },
            beforeUpload(file) {
               // const isJPG = file.type === 'image/jpeg';
                const isLt2M = file.size / 1024 / 1024 < 2;

               // if (!isJPG) {
                //    this.$message.error('上传头像图片只能是 JPG 格式!');
              //  }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                return isLt2M;
            },
            select(data) {
                this.unitIndustryStr = data[0].title;
            },
            loadData() {


                let parames = new URLSearchParams();

                this.$axios.post(this.serverUrl + '/industry/getIndustryZtreeData', parames).then(resp => {


                    if (resp.data.code === 1) {
                        let ArrayList1 = [];
                        resp.data.data.forEach(ele => {

                            let data = {
                                id: '',
                                title: '',
                                children: []
                            }

                            data.title = ele.name
                            data.id = ele.id;



                            let ArrayList = [];
                            ele.children.forEach(ele => {

                                let data1 = {
                                    id: '',
                                    title: '',
                                    fId: ''
                                }

                                data1.id = ele.id
                                data1.title = ele.name

                                data1.fId = ele.pId
                                ArrayList.push(data1);
                            })

                            data.children = ArrayList;

                            ArrayList1.push(data);
                        })

                        this.data = ArrayList1
                    }




                }).catch(err => {
                    this.$message({
                        message: '服务器异常！',
                        type: 'warning'
                    });
                });

            },
            aaa() {
                this.dialogVisible = true;

            },
            //立即注册
            signUpRightAway() {
                if (this.unitName === '') {
                    this.$message({
                        message: '请输入单位名称！',
                        type: 'warning'
                    });

                    return false;
                } else if (this.idCard === '') {
                    this.$message({
                        message: '请输入身份证号',
                        type: 'warning'
                    });
                    return false;
                } else if (this.unitTelephone === '') {
                    this.$message({
                        message: '请输入单位电话',
                        type: 'warning'
                    });
                    return false;
                } else if (this.unitContacts === '') {
                    this.$message({
                        message: '请填写单位联系人',
                        type: 'warning'
                    });
                    return false;
                }else if (this.unitContactsTel === '') {
                    this.$message({
                        message: '请填写联系电话',
                        type: 'warning'
                    });
                    return false;
                }else if (this.unitCertificatesCode === '') {
                    this.$message({
                        message: '请填写统一社会信用码',
                        type: 'warning'
                    });
                    return false;
                }

                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                let parames = new URLSearchParams();
                parames.append('unitName', this.unitName);
                parames.append('unitTelephone', this.unitTelephone);
                parames.append('unitContacts', this.unitContacts);
                parames.append('unitContactsTel', this.unitContactsTel);
                parames.append('unitLevelStr', this.unitLevelStr);
                parames.append('unitNatureStr', this.unitNatureStr);
                parames.append('unitIndustryStr', this.unitIndustryStr);
                parames.append('unitAddress', this.unitAddress);
                parames.append('unitType', this.radio);
                parames.append('unitPassword', this.unitPassword);
                parames.append('unitCertificatesCode', this.unitCertificatesCode);
                parames.append('unitCertificates', this.unitCertificates);
               

                this.$axios.post(this.serverUrl + '/unit/addUnit', parames).then(resp => {
                    loading.close();

                    if(resp.data.code === 1){
                        this.$message({
                        message: '注册成功！',
                        type: 'warning'
                        });
                        setTimeout(()=>{
                            window.location.href = 'http://39.101.244.20:8084/jnAdmin/lg/jl'
                        },1500)
                    }else{
                        this.$message({
                        message: resp.data.msg,
                        type: 'warning'
                    });
                    }   

                    setTimeout(() => {
                        this.$router.push({ path: '/login' });
                    }, 1000);

                }).catch(err => {
                    this.$message({
                        message: '服务器异常！',
                        type: 'warning'
                    });
                });

            },
            immediately() {
                this.$router.push('/login');
            }

        }

    }
</script>

<style src="../../static/css/login.css" scoped></style>

<style>
    .el-upload__input {
        display: none !important;
    }

    .v-modal {
        position: fixed;
        left: 0;
        top: 0;
        width: 0%;
        height: 0%;
        opacity: .5;
        background: white !important;
    }

    .row:before {
        display: table;
        content: " ";
    }

    .quanping {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .wrong {
        border-color: red;
    }

    .ant-form-item-control {
        width: 100%;
        margin-right: 1%;
        display: inline-block;
    }

    /*下拉菜单修改padding-left属性*/
    .layui-input,
    .layui-textarea {
        display: block;
        width: 100%;
        padding-left: 11px;
    }

    .layui-form-select .layui-input {
        padding-right: 30px;
        cursor: pointer;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        transition: all .3s;
    }

    .layui-input,
    .layui-select,
    .layui-textarea {
        height: 40px;
        line-height: 1.3;
        line-height: 38px \9;
        border-width: 1px;
        border-style: solid;
        background-color: #fff;
        border-radius: 2px;
    }



    /*修改滚动条样式*/
    ::-webkit-scrollbar {
        width: 4px;
        height: 10px;
        /**/
    }

    ::-webkit-scrollbar-track {
        background: rgb(239, 239, 239);
        border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background: #bfbfbf;
        border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #333;
    }

    ::-webkit-scrollbar-corner {
        background: #179a16;
    }

    /*修改滚动条样式*/

    /*table样式*/
    .tree_table>thead>tr>th,
    .table>tbody>tr>th,
    .table>tfoot>tr>th,
    .table>thead>tr>td,
    .table>tbody>tr>td,
    .table>tfoot>tr>td,
    .table-bordered {
        border-top: 1px solid #ebeff2 !important;
    }

    .table {
        margin-bottom: 25px;
    }

    tbody {
        color: #797979;
    }

    .table-striped>tbody>tr:nth-of-type(odd),
    .table-hover>tbody>tr:hover,
    .table>thead>tr>td.active,
    .table>tbody>tr>td.active,
    .table>tfoot>tr>td.active,
    .table>thead>tr>th.active,
    .table>tbody>tr>th.active,
    .table>tfoot>tr>th.active,
    .table>thead>tr.active>td,
    .table>tbody>tr.active>td,
    .table>tfoot>tr.active>td,
    .table>thead>tr.active>th,
    .table>tbody>tr.active>th,
    .table>tfoot>tr.active>th {
        background-color: #f4f8fb !important;
    }

    .tree_table>thead>tr>th,
    .table>tbody>tr>th,
    .table>tfoot>tr>th,
    .table>thead>tr>td,
    .table>tbody>tr>td,
    .table>tfoot>tr>td,
    .table-bordered {
        border-top: 1px solid #ebeff2 !important;
    }

    .table td,
    .table th {
        padding: 8px;
    }

    .width-15 {
        width: 15%;
    }

    .width-35 {
        width: 35%;
    }

    .pull-right {
        float: right;
    }

    table {
        border: 1px solid #ebeff2;
        font-size: 13px;
    }

    .layui-upload-drag {
        position: relative;
        padding: 13px;
        border: 1px dashed #e2e2e2;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
        color: #999;
    }

    #form-style {
        margin-top: 100px;
        width: 960px;
        background: rgb(255, 255, 255);
        border-radius: 20px;
        padding-left: 40px;
        box-shadow: rgba(235, 235, 235, 0.54) 0px 6px 10px 1px;
        padding-right: 40px;
        padding-top: 50px;
        padding-bottom: 20px;
    }

    /*上传图片框框*/
</style>


// WEBPACK FOOTER //
// src/components/unitRegister.vue